module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "trumbowyg-editor"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-022a4400"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trumbowyg.vue
// module id = 774
// module chunks = 1